import { GraduationCap, BookOpenCheck, Sparkles } from 'lucide-react';
import { useSite } from '../lib/SiteContentContext';

const iconMap = { GraduationCap, BookOpenCheck, Sparkles };

export default function Pillars() {
  const { pillars } = useSite();
  return (
    <section className="py-14 md:py-20 container" aria-labelledby="why-heading">
      <div className="max-w-3xl">
        <div className="text-brand-coral text-sm font-semibold uppercase tracking-widest">Why Science Sorted</div>
        <h2
          id="why-heading"
          className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl text-brand-ink"
        >
          Teacher-led. <span className="italic text-brand-teal">Examiner-informed.</span>
        </h2>
        <p className="mt-3 text-brand-ink/70 text-base md:text-lg">
          Every lesson and resource is designed by qualified UK teachers who understand what mark schemes reward.
        </p>
      </div>

      <div className="mt-8 md:mt-10 grid md:grid-cols-3 gap-5 md:gap-6">
        {pillars.map((p) => {
          const Icon = iconMap[p.icon];
          return (
            <div
              key={p.id}
              className="group relative rounded-3xl bg-white p-5 md:p-6 border border-brand-ink/10 hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <div className="w-12 h-12 rounded-2xl bg-brand-sun/40 grid place-items-center ring-1 ring-brand-sun/60">
                <Icon className="w-6 h-6 text-brand-ink" aria-hidden="true" />
              </div>
              <h3 className="mt-4 font-display text-xl md:text-2xl text-brand-ink whitespace-nowrap">
                {p.title}
              </h3>
              <p className="mt-2 text-brand-ink/75 text-base leading-relaxed">{p.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
